import { createReducer, Action, on } from '@ngrx/store';

import * as CropAidActions from './crop-aid.actions';
import { CropAidState } from '../crop-aid.model';

const reducer = createReducer<CropAidState>(
  {},
  on(CropAidActions.setCropAids, (state, { cropAids }) => ({ ...state, cropAids })),
);

export function cropAidReducer(state: CropAidState | undefined, action: Action) {
  return reducer(state, action);
}
